<template>
  <div>
    <v-data-table :headers="headers" :items="items" :items-per-page="-1" class="elevation-1" dark>
      <template v-slot:top>
        <v-toolbar flat dark color="grey darken-3">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="$emit('add')">
            <v-icon left>mdi-plus</v-icon>
            Neu
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.flexActive="{ item }">
        <v-chip :color="item.flexActive ? 'orange' : 'green'" small>
          {{ item.flexActive ? "Flexibel" : "Fix" }}
        </v-chip>
      </template>

      <template v-slot:item.noSignUpFee="{ item }">
        <v-chip v-if="item.noSignUpFee" :color="item.noSignUpFee ? 'orange' : 'green'" small>
          {{ item.noSignUpFee ? "Kein Aktivierungstarif" : "Mit Aktivierungstarif" }}
        </v-chip>
      </template>

      <template v-slot:item.showAsUpgradePossibility="{ item }">
        <v-chip v-if="item.showAsUpgradePossibility" :color="item.showAsUpgradePossibility ? 'green' : 'orange'" small>
          {{ item.showAsUpgradePossibility ? "Ja" : "Nein" }}
        </v-chip>
      </template>
      <template v-slot:item.calculateWithEndDate="{ item }">
        <v-chip v-if="item.calculateWithEndDate" :color="item.calculateWithEndDate ? 'green' : 'orange'" small>
          {{ item.calculateWithEndDate ? "Ja" : "Nein" }}
        </v-chip>
      </template>
      <template v-slot:item.calculateWithEndDateSixMonths="{ item }">
        <v-chip v-if="item.calculateWithEndDateSixMonths" :color="item.calculateWithEndDateSixMonths ? 'green' : 'orange'" small>
          {{ item.calculateWithEndDateSixMonths ? "Ja" : "Nein" }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom v-if="title === 'Mitgliedschaften'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="$emit('rename', item)"> mdi-form-textbox </v-icon>
          </template>
          <span>Umbenennen</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="$emit('edit', item)"> mdi-pencil </v-icon>
          </template>
          <span>Bearbeiten</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" @click="$emit('delete', item)"> mdi-delete </v-icon>
          </template>
          <span>Löschen</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "SettingsSection",
  props: {
    title: String,
    items: Array,
    headers: Array,
  },
}
</script>
